(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-items"]) return;
  try {
    
(function() {
  var section = document.querySelector('[data-section-id]');
  if (!section) return;

  function updateCart(key, quantity) {
    fetch('/cart/change.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      if (quantity === 0) {
        var item = document.querySelector('[data-key="' + key + '"].esstore-cart__item');
        if (item) item.remove();
        if (cart.item_count === 0) {
          window.location.reload();
          return;
        }
      }
      var subtotalEl = document.getElementById('esstore-cart-subtotal');
      var totalEl = document.getElementById('esstore-cart-total');
      var formatted = formatMoney(cart.total_price);
      if (subtotalEl) subtotalEl.textContent = formatted;
      if (totalEl) totalEl.textContent = formatted;
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    })
    .catch(function() {});
  }

  function formatMoney(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  section.addEventListener('click', function(e) {
    var btn = e.target.closest('.esstore-cart__qty-btn, .esstore-cart__remove');
    if (!btn) return;

    var key = btn.dataset.key;
    if (!key) return;

    if (btn.classList.contains('esstore-cart__remove')) {
      updateCart(key, 0);
      return;
    }

    var input = section.querySelector('.esstore-cart__qty-input[data-key="' + key + '"]');
    if (!input) return;
    var qty = parseInt(input.value, 10) || 1;

    if (btn.dataset.action === 'increase') {
      qty += 1;
    } else {
      qty = Math.max(0, qty - 1);
    }

    input.value = qty;
    updateCart(key, qty);
  });

  section.addEventListener('change', function(e) {
    var input = e.target.closest('.esstore-cart__qty-input');
    if (!input) return;
    var qty = Math.max(0, parseInt(input.value, 10) || 0);
    input.value = qty;
    updateCart(input.dataset.key, qty);
  });

  /* CEP calculator using ViaCEP */
  var cepBtn = document.getElementById('esstore-cep-btn');
  var cepInput = document.getElementById('esstore-cep-input');
  var cepResult = document.getElementById('esstore-cep-result');

  if (cepInput) {
    cepInput.addEventListener('input', function() {
      var v = cepInput.value.replace(/\D/g, '').slice(0, 8);
      cepInput.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });
  }

  if (cepBtn) {
    cepBtn.addEventListener('click', function() {
      var cep = cepInput ? cepInput.value.replace(/\D/g, '') : '';
      if (cep.length !== 8) {
        if (cepResult) {
          cepResult.textContent = 'CEP inválido. Digite 8 dígitos.';
          cepResult.className = 'esstore-cart__cep-result is-error';
        }
        return;
      }
      cepBtn.disabled = true;
      cepBtn.textContent = '...';
      if (cepResult) {
        cepResult.textContent = 'Consultando...';
        cepResult.className = 'esstore-cart__cep-result';
      }
      fetch('https://viacep.com.br/ws/' + cep + '/json/')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          cepBtn.disabled = false;
          cepBtn.textContent = 'Calcular';
          if (data.erro) {
            cepResult.textContent = 'CEP não encontrado.';
            cepResult.className = 'esstore-cart__cep-result is-error';
          } else {
            cepResult.textContent = data.localidade + ' / ' + data.uf + ' — Frete calculado no checkout.';
            cepResult.className = 'esstore-cart__cep-result is-success';
          }
        })
        .catch(function() {
          cepBtn.disabled = false;
          cepBtn.textContent = 'Calcular';
          if (cepResult) {
            cepResult.textContent = 'Erro ao consultar. Tente novamente.';
            cepResult.className = 'esstore-cart__cep-result is-error';
          }
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-products"]) return;
  try {
    
(function() {
  document.querySelectorAll('.esstore-prod-card__quick-add').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.textContent = 'Adicionando...';
      btn.disabled = true;

      fetch('/cart/add.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = 'Adicionado!';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        setTimeout(function() {
          btn.textContent = 'Adicionar ao carrinho';
          btn.disabled = false;
        }, 2000);
      })
      .catch(function() {
        btn.textContent = 'Adicionar ao carrinho';
        btn.disabled = false;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* Sticky Header — custom element compatível com Dawn */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.isAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.isAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideOnScrollUp = () => { this.preventReveal = true; };

      this.addEventListener('preventHeaderReveal', this.hideOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }

    setHeaderHeight() {
      if (this.header) {
        document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      var self = this;
      var observer = new IntersectionObserver(function(entries, obs) {
        self.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      if (this.header) observer.observe(this.header);
    }

    onScroll() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.isAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          if (!this.isAlwaysSticky) requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.add('shopify-section-header-sticky');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* Drawer mobile */
  (function () {
    var hamburger = document.getElementById('esstore-hamburger');
    var drawer    = document.getElementById('esstore-mobile-drawer');
    var closeBtn  = document.getElementById('esstore-drawer-close');
    var overlay   = document.getElementById('esstore-drawer-overlay');

    if (!hamburger || !drawer) return;

    function openDrawer() {
      drawer.setAttribute('aria-hidden', 'false');
      hamburger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeBtn && closeBtn.focus();
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      hamburger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      hamburger.focus();
    }

    hamburger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay)  overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
        closeDrawer();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var heroes = document.querySelectorAll('[data-esstore-hero]');

    heroes.forEach(function (el) {
      var slides   = Array.from(el.querySelectorAll('.esstore-hero__slide'));
      var dots     = Array.from(el.querySelectorAll('[data-hero-dot]'));
      var prevBtn  = el.querySelector('[data-hero-prev]');
      var nextBtn  = el.querySelector('[data-hero-next]');
      var total    = slides.length;
      var current  = 0;
      var autoplay = el.dataset.autoplay === 'true';
      var speed    = parseInt(el.dataset.speed, 10) || 5000;
      var timer    = null;

      if (total <= 1) return;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          dots[current].setAttribute('aria-selected', 'false');
        }

        current = ((index % total) + total) % total;

        slides[current].classList.add('is-active');
        slides[current].setAttribute('aria-hidden', 'false');
        if (dots[current]) {
          dots[current].classList.add('is-active');
          dots[current].setAttribute('aria-selected', 'true');
        }
      }

      function startAutoplay() {
        stopAutoplay();
        timer = setInterval(function () { goTo(current + 1); }, speed);
      }

      function stopAutoplay() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        goTo(current - 1);
        if (autoplay) startAutoplay();
      });

      if (nextBtn) nextBtn.addEventListener('click', function () {
        goTo(current + 1);
        if (autoplay) startAutoplay();
      });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          goTo(parseInt(dot.dataset.heroDot, 10));
          if (autoplay) startAutoplay();
        });
      });

      el.addEventListener('mouseenter', stopAutoplay);
      el.addEventListener('mouseleave', function () {
        if (autoplay) startAutoplay();
      });

      var touchStartX = 0;
      el.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
      }, { passive: true });

      el.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 50) {
          dx < 0 ? goTo(current + 1) : goTo(current - 1);
          if (autoplay) startAutoplay();
        }
      });

      el.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft')  { goTo(current - 1); if (autoplay) startAutoplay(); }
        if (e.key === 'ArrowRight') { goTo(current + 1); if (autoplay) startAutoplay(); }
      });

      if (autoplay) startAutoplay();

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
          stopAutoplay();
        } else if (autoplay) {
          startAutoplay();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
